import request from '@/utils/request'

// 查询优惠券活动列表
export function listCouponActivity(query) {
  return request({
    url: '/coupon/coupon-activity/list',
    method: 'get',
    params: query
  })
}

// 查询优惠券活动分页
export function pageCouponActivity(query) {
  return request({
    url: '/coupon/coupon-activity/page',
    method: 'get',
    params: query
  })
}

// 查询优惠券活动详情
export function getCouponActivity(params) {
  return request({
    url: '/coupon/coupon-activity/detail',
    method: 'get',
    params: params
  })
}

// 新增优惠券活动
export function addCouponActivity(data) {
  return request({
    url: '/coupon/coupon-activity/add',
    method: 'post',
    data: data
  })
}

// 修改优惠券活动
export function updateCouponActivity(data) {
  return request({
    url: '/coupon/coupon-activity/edit',
    method: 'post',
    data: data
  })
}

// 删除优惠券活动
export function delCouponActivity(data) {
  return request({
    url: '/coupon/coupon-activity/delete',
    method: 'post',
    data: data
  })
}
